module.exports = __webpack_public_path__ + "img/st.568b2c5e.png";